"use client";

import React from "react";
import { MonitorPlay, AudioWaveform, CalendarClock, Waves, ArrowRight, Hospital, Building2, Dices, Briefcase } from "lucide-react";
import { Button } from "@/components/ui/button";
import { Link } from "@/components/common/Link";
import { useRevealOnScroll } from "@/hooks/useRevealOnScroll";
import { cn } from "@/lib/utils";
const expertiseAreas = [{
  title: "Direct View LED Video Walls",
  description: "Deliver breathtaking, seamless visual experiences with high-resolution LED displays tailored for command centers, lobbies, and auditoriums. ",
  icon: MonitorPlay,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/led_video_wall_immersive.png",
  className: "md:col-span-2 md:row-span-2 min-h-[400px] md:min-h-[500px]",
  large: true,
  titleClassName: "relative z-10 p-6 flex flex-col h-full justify-end relative z-10 p-6 flex flex-col h-full justify-end !bg-transparent !text-transparent md:p-8 md:p-8 !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/IMG_4990-1.jpg)] relative z-10 p-6 flex flex-col h-full justify-end relative z-10 p-6 flex flex-col h-full justify-end !bg-transparent !text-transparent md:p-8 md:p-8 !bg-[url(https://suitable-martin.10web.cloud/wp-content/uploads/2026/03/New-Project.jpg)]"
}, {
  title: "Professional Audio",
  description: "Engineered sound systems ensuring crystal-clear communication and immersive audio across all environments.",
  icon: AudioWaveform,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/pro_audio_integration.png",
  className: "md:col-span-2 md:row-span-1 min-h-[250px]",
  large: false
}, {
  title: "Room Scheduling",
  description: "Intuitive booking interfaces that streamline workspace management and optimize room utilization.",
  icon: CalendarClock,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/room_scheduling_panels.png",
  className: "md:col-span-1 md:row-span-1 min-h-[250px]",
  large: false
}, {
  title: "Sound Masking",
  description: "Advanced acoustic solutions to protect speech privacy and reduce distractions in open office environments.",
  icon: Waves,
  image: "https://wpvc-images.s3.us-east-1.amazonaws.com/images/1576635/img/sound_masking_system.png",
  className: "md:col-span-1 md:row-span-1 min-h-[250px]",
  large: false
}];
export default function SpecializedDesignExpertise() {
  const {
    ref,
    isVisible
  } = useRevealOnScroll({
    threshold: 0.1
  });
  return <section id="specialized-design-expertise" className="dark bg-background text-foreground py-24 px-4 md:px-8 overflow-hidden">
      <div className="max-w-7xl mx-auto">
        <div className="mb-16 md:mb-20 max-w-3xl">
          <h2 className="text-3xl md:text-5xl font-bold tracking-tight mb-6">
            Precision <span className="!text-[rgba(204,5,5,0.9647058823529412)]">Integration</span>
          </h2>
          <p className="text-lg text-muted-foreground leading-relaxed">
            We specialize in delivering fully integrated, custom audiovisual systems tailored to your unique business environment. As a turnkey provider, we are your one-stop shop for comprehensive AV solutions—from concept to completion.
          </p>
        </div>

        <div ref={ref} className={cn("grid grid-cols-1 md:grid-cols-4 gap-4 md:gap-6 transition-all duration-1000 ease-out", isVisible ? "opacity-100 translate-y-0" : "opacity-0 translate-y-12")}>
          {expertiseAreas.map((item, i) => <div key={item.title} data-index={i} className={cn("group relative overflow-hidden rounded-2xl border border-border/50 bg-card flex flex-col justify-end transition-all duration-500 hover:border-primary/50 hover:shadow-[0_0_30px_-15px_rgba(var(--color-primary),0.3)]", item.className)}>
              {}
              <div className="absolute inset-0 bg-cover bg-center transition-transform duration-700 group-hover:scale-105" style={{
            backgroundImage: `url(${item.image})`
          }} />
              
              {}
              <div className={cn("absolute inset-0 transition-colors duration-500", item.large ? "bg-background/70 backdrop-blur-[4px] group-hover:bg-background/50 group-hover:backdrop-blur-[2px]" : "bg-background/85 backdrop-blur-md group-hover:bg-background/70")} />

              {}
              <div className={`${item.titleClassName || ""} relative z-10 p-6 flex flex-col h-full justify-end relative z-10 p-6 flex flex-col h-full justify-end !bg-transparent !text-transparent md:p-8 md:p-8`}>
                <div className="mb-4 inline-flex h-12 w-12 items-center justify-center rounded-lg bg-background/50 backdrop-blur-md border border-border/50 text-primary shadow-lg">
                  <item.icon className="size-6" />
                </div>
                <h3 className="font-bold mb-3 text-2xl !text-[hsl(0,95%,41%)] md:text-3xl">
                  {item.title}
                </h3>
                <p className="text-base max-w-xl !text-[hsl(210,17%,98%)] md:text-lg">
                  {item.description}
                </p>
              </div>
            </div>)}
        </div>

        <div className="mt-16 flex justify-center">
          <Link to="/SolutionsPage">
            
          </Link>
        </div>
      </div>
    </section>;
}